import LiveEventService from '../../services/LiveEventService'
import router from '../../router'

const state = () => ({
    liveEventLoading: false,
    liveEvent: null
})
  
const mutations = {
    SET_LIVE_EVENT: (state, payload) => {
        state.liveEvent = payload;
    },
    SET_LOADING_LIVE_EVENT: (state, payload) => {
        state.liveEventLoading = payload
    },
}

const actions = {
    async fetchLiveEvent({commit}, webinarId){
        try{
            commit('SET_LOADING_LIVE_EVENT', true)
            const response = await LiveEventService.getOne(webinarId);
            commit('SET_LIVE_EVENT', response.data.link)
            commit('SET_LOADING_LIVE_EVENT', false)
        } catch (error) {
            commit('SET_LOADING_LIVE_EVENT', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
}

const getters = {
    getLiveEvent: state => state.liveEvent,
    getLoadingLiveEvent: state => state.liveEventLoading,
}

export default {
    state,
    getters,
    mutations,
    actions
};